import { Textarea as ChakraTextarea, TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { fieldPropTypes } from '../../molecules/Input/Input';
import { forwardRef } from '../../system';

import DisplayNames from './enum';

export const resizeOptions = ['horizontal', 'vertical', 'none', 'both'];
export const variantPropTypes = ['basic', 'outline', 'filled', 'unstyled'];

const propTypes = {
  ...fieldPropTypes,
  variant: PropTypes.oneOf(variantPropTypes),
  resize: PropTypes.oneOf(resizeOptions)
};
const defaultProps = {
  variant: 'basic',
  size: 'md',
  resize: 'vertical'
};

export type TextareaProps = ChakraTextareaProps;

const Textarea = forwardRef((props: TextareaProps, ref) => {
  return <ChakraTextarea {...props} ref={ref} />;
});

Textarea.displayName = DisplayNames.Textarea;
Textarea.propTypes = propTypes;
Textarea.defaultProps = defaultProps;
export default Textarea;
